import { useEffect, useRef } from 'react';
import mixpanelService from '../services/mixpanel';

export const usePageTracking = (pageName, additionalProperties = {}) => {
  // Stabilize the object reference so callers don't need to memoize it.
  // We serialize to JSON and only fire when the value actually changes.
  const serialized = JSON.stringify(additionalProperties);
  const propsRef = useRef(additionalProperties);
  propsRef.current = additionalProperties;

  useEffect(() => {
    if (pageName) {
      mixpanelService.trackPageView(pageName, propsRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageName, serialized]);
};

export default usePageTracking;